import { BpsAdminDashboardData } from "../model/bps-admin/bps-admin-dashboard-data";
import { BpsAdminDashboardChartDataList } from "../model/bps-admin/bps-admin-dashboard-chart-data-list";
import { LoanSummaryResponse } from "../pages/admin/loan-summary/LoanSummaryPage";
import moment from "moment";
import { apiSlice } from "../stores/base/api-slice";
import { toQueryString } from ".";

const bpsAdminEndpoints = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBpsAdminDashboard: builder.query<BpsAdminDashboardData, void>({
      query: () => ({
        url: "/bps-admin/dashboard",
        method: "GET",
      }),
      providesTags: ["BpsAdminDashboard"],
    }),
    
    getBpsAdminDashboardChart: builder.query<
      BpsAdminDashboardChartDataList,
      { startDate: Date; endDate: Date }
    >({
      query: ({ startDate, endDate }) => {
        const start = moment(startDate).format();
        const end = moment(endDate).format();
        return {
          url: "/bps-admin/dashboard/chart" + toQueryString({ startDate: start, endDate: end }),
          method: "GET",
        };
      },
      providesTags: ["BpsAdminDashboardChart"],
    }),
    
    downloadBpsAdminDashboardChart: builder.mutation<Blob, BpsAdminDashboardChartDataList>({
      query: (chartData) => ({
        url: "/bps-admin/dashboard/chart/download",
        method: "POST",
        body: chartData,
        responseHandler: (response : Response) => response.blob(),
      }),
    }),
    
    getLoanSummary: builder.query<LoanSummaryResponse, void>({
      query: () => ({
        url: "/bps-admin/loan-summary",
        method: "GET",
      }),
      providesTags: ["LoanSummary"],
    }),
  }),
});

export const {
  useGetBpsAdminDashboardQuery,
  useLazyGetBpsAdminDashboardQuery,
  useGetBpsAdminDashboardChartQuery,
  useLazyGetBpsAdminDashboardChartQuery,
  useDownloadBpsAdminDashboardChartMutation,
  useGetLoanSummaryQuery,
  useLazyGetLoanSummaryQuery,
} = bpsAdminEndpoints;